<template>
  <v-card class="align-stretch" height="100%">
    <v-card-title>
      Provisioning
      <v-spacer></v-spacer>
      <v-btn color="secondary" x-small @click="editProvisioningOpen=true;"><v-icon small>edit</v-icon></v-btn>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="secondary" class="ml-2" x-small :href="queueUrl" target="_blank"><v-icon small>{{queueIcon}}</v-icon></v-btn>
        </template>
        <span>Provisioning Queue</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <p class="mb-1 text-caption">Future Live Date</p>
          <p><b>{{currentProduct.future_live_date | dateFormat}}</b></p>
        </v-col>
      </v-row>
    </v-card-text>
    <EditProvisioning :dialogOpen="editProvisioningOpen" @close-dialog="editProvisioningOpen=false;" />
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';
  import EditProvisioning from './EditProvisioning';
  import moment from 'moment';
  import { mdiFormatListText } from '@mdi/js';
  export default {
    components: {EditProvisioning},
    data() {
      return {
        editProvisioningOpen: false,
        queue_url: process.env.VUE_APP_QUEUE_URL || `https://queues-bonline-testing.appspot.com/`,
        queueUrl: '',
        queueIcon: mdiFormatListText,
      }
    },
    computed: {
      ...mapState('products',['currentProduct']),
      ...mapState("accounts", ["currentAccount"]),
    },
    mounted () {
      this.queueUrl = `${this.queue_url}voip-provisioning/actions/?site_id=${this.currentProduct.id}`;
    },
    filters: {
      dateFormat: function(val) {
        return (val!==undefined&&val!==null&&val!=='')?moment(val).format('YYYY-MM-DD'):'-';
      }
    }
  }
</script>

<style lang="scss" scoped></style>
